import React from 'react'
import { I18n } from '@front/volcanion'

import { Box, Typography, Grid } from '@mui/material'
import { TextField } from '@front/squirtle'

const Title = props =>
  <Grid size={12}>
    <Typography variant={'h5'}> {I18n.t('rateparameter.search')} </Typography>
  </Grid>

const Row1 = props =>
  <Grid container spacing={1} size={12}>
    <Grid size="grow">
      <TextField name={'name'} label={I18n.t('name.label', { count: 1 })} />
    </Grid>
  </Grid>

const SearchForm = props =>
  <Box sx={{ p: 1, boxShadow: 6, borderRadius: 1 }}>
    <Grid container rowSpacing={3}>
      <Title />
      <Row1 />
    </Grid>
  </Box>


export default React.memo(SearchForm)
